module.exports = {
  "search.exact": "exakt",
  "search.fuzzy": "unscharf"
}